<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-320.001 -119)">
			<path
				d="M20.75,2A18.75,18.75,0,1,0,39.5,20.75,18.757,18.757,0,0,0,20.75,2Zm0,5.625a5.625,5.625,0,1,1-5.625,5.625A5.617,5.617,0,0,1,20.75,7.625Zm0,26.625A13.5,13.5,0,0,1,9.5,28.213c.056-3.731,7.5-5.775,11.25-5.775,3.731,0,11.194,2.044,11.25,5.775A13.5,13.5,0,0,1,20.75,34.25Z"
				transform="translate(321.751 120.75)"
			/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(320.001 119)" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-account-circle',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
path.a {
	fill: none;
}
</style>

<docs>
	IconAccountCircle

	```js
	<b-icon-account-circle />
	```
</docs>
